const { makeStyles } = require('@material-ui/core')

const ticketStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(7.2),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: '#F7F6FC',
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: theme.spacing(1.6),
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
  gridContainer: {
    marginTop: theme.spacing(0.8),
    alignSelf: 'flex-start',
  },
  table: {
    marginTop: theme.spacing(2.4),
  },
  printTicketContainer: {
    display: 'none',
  },
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  printButton: {
    height: 56,
    marginLeft: 16,
    marginRight: 16,
  },
}))

export default ticketStyles
